import FullTable from 'js/components/full-table/index.js'
import { openModalConfirmRemove } from 'js/services/modals.js'
import { accounts } from '/mocks/super-admin/factory.js' // ✅ Importa directamente desde el mock

import template from './_table.pug'

export default Vue.extend({
  template: template(),
  components: {
    FullTable
  },
  props: {
    superAdmins: {
      type: Array,
      required: true
    },
    meta: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      showFilters: true,
      filters: { fullName: '', accountId: '' },
      accountsOptions: [],
      lastQueryOptions: null
    }
  },
  computed: {
    canManage() {
      return this.$user.permissions.includes('MANAGE_LAIA_ADMIN')
    },
    defaultOrder() {
      return { currentField: 'createdAt', currentDir: 'desc' }
    },
    filterButtonParams() {
      return this.showFilters ? { class: 'active', icon: 'angle-up' } : { class: '', icon: 'angle-down' }
    }
  },
  created() {
    this.loadAccounts()
  },
  methods: {
    // 🔁 CORREGIDO: usamos los mocks directamente
    loadAccounts() {
      this.accountsOptions = accounts.map(account => ({
        label: account.name,
        value: account.id
      }))
    },

    t(key, options = {}) {
      return this.$t(`superAdmins.index.${key}`, options)
    },

    confirmDelete(superAdmin) {
      openModalConfirmRemove(
        this.t('confirmationModal.remove.title'),
        this.t('confirmationModal.remove.body', { name: superAdmin.firstName }),
        this.t('confirmationModal.remove.okButton')
      ).then(() => this.destroy(superAdmin.id))
    },

    getData(queryOptions) {
      this.$emit('load-data', queryOptions || this.lastQueryOptions)
      this.lastQueryOptions = queryOptions || this.lastQueryOptions
    },

    destroy(id) {
      API.superAdmins.destroy(id)
        .then(() => {
          this.$notifications.success(this.t('succesfullyDeleted'))
          this.getData()
        })
        .catch(error => console.error("Error al eliminar Super Admin:", error))
    }
  }
})
